import { MOCK_NOTIFICATIONS } from '@common/components/NotificationDrawer/notification-drawer.mock-data.const'

import type { NotificationsStoreState } from './notifications.type'

export const notificationsInitialState: NotificationsStoreState = {
  notifications: MOCK_NOTIFICATIONS,
}
